/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconDirections extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "DirectionsIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M320-360h60v-130h184v85l116-115-116-116v86H350q-13 0-21.5 8.5T320-520v160ZM480-77q-12 0-23.5-4T437-93L93-437q-8-8-12-19.5T77-480q0-12 4-23.5T93-523l344-344q8-8 19.5-12t23.5-4q12 0 23.5 4t19.5 12l344 344q8 8 12 19.5t4 23.5q0 12-4 23.5T867-437L523-93q-8 8-19.5 12T480-77Z"/></svg>
    `;
}
